// extracted by mini-css-extract-plugin
export default {"roomsceneListContainer":"RoomSceneList_roomsceneListContainer__i93wC","roomsceneList":"RoomSceneList_roomsceneList__vUiv8"};